class ResourceDirective
  @$inject: ["$rootScope", "$injector", "$timeout", "$q"]
  constructor: ($rootScope, $injector, $timeout, $q)->                
    class Resource
      scope: true
      bindToController: true
      controllerAs: "$resource"
      controller: ($scope, $element, $attrs)->
        @Model = $q (resolve, reject)->
          $attrs.$observe "restfulResources", (val)->        
            resolve($injector.get(val))
        if $attrs.manually?.length is 0 
          @manually = true
        @method = $attrs.method ? "paginate";
        @limit = $attrs.limit ? 10;
        @sorting = eval($attrs.sorting) ? []        
        @options = {}
        @filtering = {}

        @refresh = ()=>
          @options = 
            page: 1
            sort: @sorting   
          if $scope.$parent.pageTitle is "Apps & Resources"
            @options.folder = ""        
          @query()

        @move = (page)=>
          @options.page = page
          @query()
        
        @search = (val)=>
          @options = 
            page: 1
            sort: @sorting
            search: val       
          @query()

        @filter = (filtering)=>
          @filtering = filtering
          @query()

        @sort = ()=>
          @options.sort = @sorting
          @query()

        @assignSelect = (selecteds, dataset)=>
          newDataset = dataset
          for selected in selecteds
            for device in dataset
              if selected._id is device._id
                device.$selected = true
          return newDataset

        @query = ()=>
          @options.limit = @limit
          @options.fields = @fields
          if @filtering
            for key in Object.keys(@filtering)
              @options[key] = @filtering[key]
          $scope.$loading = true
          @Model.then (Resource)=>
            @options.sort = @sorting
            Resource[@method](@options).$promise
          .then (result)=>
            if $scope.$parent.controllerTitle is "Device Management"
              if result
                for device in result
                  if device._id
                    device.$selected = false
              if $scope.$parent.selected and $scope.$parent.selected.length > 0
                result = @assignSelect $scope.$parent.selected, result
            $scope.$pagination = result.$pagination 
            $scope.$dataset = result
            # console.log $scope.$dataset
            $scope.loading = false          
          .catch ()->
            $scope.loading = false
        
        $scope.$watch $attrs.search, (val)=>          
          if not @manually
            if val or val?.length is 0
              @search(val)
        , true

        $scope.$watch $attrs.filter, (val)=>          
          if not @manually
            if val or val?.length is 0            
              @filter(val)
        , true

        if not $attrs.hasOwnProperty("filter")
          if not @manually
            @refresh()

        $attrs.$observe 'name', (val)=>
          @name = val
          $scope.$on "#{@name}.filter", (evt, cond)=>
            @filter cond
          
        return @     
    return new Resource()

  
module.exports = ResourceDirective


// WEBPACK FOOTER //
// ./src/common/resource/restful/directive.coffee